import { AJUDAS_ORDEM, AJUDA_LABEL, type NivelAjuda } from "../types";

/**
 * Seletor do nível de ajuda (gradiente decrescente: plena → leve → verbal → nenhuma).
 * OPCIONAL: tocar o nível já marcado limpa (volta a "—"). Precisar de ajuda NÃO é um
 * passo pior — é o próprio dado clínico de autonomia. Reaproveita .status-opcoes.
 */
export function AjudaSelector({
  valor,
  onChange,
}: {
  valor: NivelAjuda | null;
  onChange: (v: NivelAjuda | null) => void;
}) {
  return (
    <div className="status-opcoes" role="group" aria-label="nível de ajuda">
      {AJUDAS_ORDEM.map((a) => {
        const sel = valor === a;
        return (
          <button
            key={a}
            type="button"
            className={`status-opt${sel ? " sel" : ""}`}
            aria-pressed={sel}
            onClick={() => onChange(sel ? null : a)}
          >
            {AJUDA_LABEL[a]}
          </button>
        );
      })}
    </div>
  );
}
